import { Component, h, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { DEFAULT_TRACKING_DELAY } from '../../../global/utility/tracking-helpers';

export interface UiCmsContactChannelsFooterEmailBody {
  emailAddress: string;
}
@Component({
  tag: 'ui-cms-contact-channels-footer-email',
  styleUrl: 'ui-cms-contact-channels-footer-email.scss',
})
export class UiCmsContactChannelsFooterEmail {
  @Prop({ mutable: true }) body: UiCmsContactChannelsFooterEmailBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ mutable: true }) i18n: { [key: string]: string } = { content: 'Per <strong>E-Mail</strong> unter' };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Watch('utilityI18n')
  i18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    this.i18nChangeHandler(this.utilityI18n);
  }

  onLinkClick() {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Email',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.body.emailAddress,
        externalTarget: `mailto:${this.body.emailAddress}`,
      },
      category: {
        area: 'Footer',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  render() {
    const mail = `mailto:${this.body.emailAddress}`;
    return (
      <div class="contactbox__item">
        <ui-icon class="contactbox__icon" icon="letter"></ui-icon>
        <p>
          <span innerHTML={this.i18n.content || 'Per <strong>E-Mail</strong> unter'}></span>{' '}
          <strong>
            <ui-link href={mail} itemProp="email" delay={DEFAULT_TRACKING_DELAY} onClick={this.onLinkClick.bind(this)}>
              {this.body.emailAddress}
            </ui-link>
          </strong>
        </p>
      </div>
    );
  }
}
